
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companydirectory",
      function () {
        return require("private-next-pages/companydirectory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companydirectory"])
      });
    }
  